<adapt-not-found-page title=" "
                      subTitle="You don't have access to the Compatibility Matrix Admin tool"
                      description="Make sure that you are on VPN. If you still can't access, contact CMX_Support@helixops.ai"
                      btnText="Request access"
                      btnLink="mailto:CMX_Support@helixops.ai?subject=Request%20access&body=Can I be authorized to access CMX Admin?"
                      btnType="primary">
</adapt-not-found-page>  